import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Accordian.jsx");
